import {useRef} from 'react';
import Button from '../../../../shared/components/Button/Button';
export default function TicketFilePicker({label='Joindre un fichier',disabled,onFile,accept='.pdf,.png,.jpg,.jpeg,.txt,.csv,.xlsx,.docx'}){
 const input=useRef(null);
 return <span><input ref={input} hidden type="file" accept={accept} disabled={disabled} aria-label={label} onChange={e=>{const f=e.target.files?.[0];e.target.value='';if(f)onFile(f);}}/><Button size="small" disabled={disabled} onClick={()=>input.current?.click()}>{label}</Button></span>;
}
